import { render } from "./FTLOrderEdit.vue?vue&type=template&id=066d0058&scoped=true&ts=true"
import script from "./FTLOrderEdit.vue?vue&type=script&lang=ts"
export * from "./FTLOrderEdit.vue?vue&type=script&lang=ts"

import "./FTLOrderEdit.vue?vue&type=style&index=0&id=066d0058&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066d0058"]])

export default __exports__